import { motion } from "framer-motion";
import { Instagram, Twitter, Youtube } from "lucide-react";
import QuizzyLogo from "./QuizzyLogo";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-[#222738] px-4 pb-10 pt-16 sm:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-center">
          <div className="flex items-center gap-3">
            <QuizzyLogo size={34} />
            <div>
              <p className="font-display text-sm font-bold text-white">QUIZZY</p>
              <p className="font-code text-[10px] tracking-widest text-[#64748B]">
                YOUR BRAIN IS THE CONTROLLER
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {[Instagram, Twitter, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#top"
                data-testid={`footer-social-${i}`}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#222738] text-[#64748B] transition-all hover:border-[#FF007A] hover:text-[#FF007A]"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-stroke-ghost mt-14 select-none text-center text-[18vw] font-extrabold leading-none sm:text-[13vw]"
        >
          QUIZZY
        </motion.p>
        <p className="mt-6 text-center font-code text-[10px] tracking-widest text-[#64748B]">
          © 2026 QUIZZY. FREE TO PLAY. ANDROID ONLY.
        </p>
      </div>
    </footer>
  );
}
